import { CircularProgress } from '@mui/material';
import { Typography } from '@design-system/components/typography/typography';
import { Avatar, Box } from '@mui/material';
import { Button } from '@design-system/components/button/button';
import { Author } from 'generated/graphql';
import { isEmpty } from 'lodash';
import { InboxViewModel } from '../viewModel/useInbox.viewModel';

type InboxBlockedUsersProps = InboxViewModel['blockedUsersList'];

export const InboxBlockedUsers = ({
  blockedUsers,
  loadingBlockedUsers,
  unblockUser,
}: InboxBlockedUsersProps) => {
  if (loadingBlockedUsers) {
    return <CircularProgress />;
  }
  return (
    <div className="flex flex-col">
      {isEmpty(blockedUsers) ? (
        <Typography variant="body" size="medium" fontWeight="normal">
          There are no blocked users
        </Typography>
      ) : (
        <BlockedUsersList users={blockedUsers} unblockUser={unblockUser} />
      )}
    </div>
  );
};

const BlockedUsersList = ({
  users,
  unblockUser,
}: {
  users: Author[];
  unblockUser: (userId: number) => void;
}) => {
  return (
    <div className="flex flex-col gap-4">
      {users.map((user) => (
        <Box
          className="flex justify-between bg-white p-4 rounded-[10px]"
          key={user.id}
        >
          <Box className="flex justify-center items-center gap-2.5">
            <Avatar
              alt={'profilePicture'}
              src={user.profilePicture}
              data-testid="avatar"
              className="self-center"
            />
            <Box className="flex flex-col justify-center gap-2">
              {user.username && (
                <Typography className="text-gray-1 text-[16px] font-extrabold">
                  {user.username}
                </Typography>
              )}
              <Typography className="text-gray-4">{user.email}</Typography>
            </Box>
          </Box>
          <Button
            className="h-[36px] self-center"
            onClick={() => unblockUser(user.id)}
          >
            Unblock user
          </Button>
        </Box>
      ))}
    </div>
  );
};
